module.exports = __webpack_public_path__ + "img/light_tank_small.765ad5b3.png";